import { toast } from "react-toastify"

export function copyToClipboard(str: string) {
  navigator.clipboard.writeText(str)
  toast.success("Copied")
}
